import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuList,
  Toolbar,
  Typography,
} from '@mui/material';
import { BottomMenuList, BottomMenuListAyuda, SideMenuList } from '../../../routes/Menu';
import { ButtonDownloadPWAiOS } from '../../../@iosper/components/PWA/ButtonDownloadPWAiOS';
import { InfoRounded, InstallDesktop, Verified } from '@mui/icons-material';
import { ItemMenuList } from './ItemMenuList';
import { useVersionControlStore } from '../../../@iosper/components/VersionControl/store/hooks';
import ButtonDownloadPWA from '../../../@iosper/components/PWA/ButtonDownloadPWA';

const DrawerButtonMenu = ({ icon, iconColor, text, textColor, children }) => {
  if (children) {
    return children;
  }

  return (
    <ListItem sx={{ minHeight: 48 }}>
      <ListItemIcon title={text ? text : ''} sx={{ color: iconColor }}>
        {icon || ''}
      </ListItemIcon>
      <ListItemText>
        <Typography variant='button' gutterBottom color={textColor} fontWeight='600'>
          {text || ''}
        </Typography>
      </ListItemText>
    </ListItem>
  );
};

export const SideMenu = () => {
  const { state } = useVersionControlStore();
  const colorVersion = () => {
    return state.isUptodate ? 'success.main' : 'warning.main';
  };

  return (
    <>
      <Toolbar />
      <Divider />

      <MenuList
        id='nav'
        aria-label='Menú lateral de navegación del sitio Tableros OSER.'
        tabIndex='0'
      >
        <ItemMenuList list={SideMenuList} />
        <ItemMenuList list={BottomMenuListAyuda} />
        <Divider />
        <ItemMenuList list={BottomMenuList} />
      </MenuList>
      <Box
        sx={{ width: '100%', display: 'flex', alignItems: 'flex-end', marginTop: { md: '20px' } }}
      >
        <List sx={{ width: '100%' }}>
          <ButtonDownloadPWA>
            <DrawerButtonMenu
              icon={<InstallDesktop />}
              text='Instalar Aplicación'
              iconColor='#1a78c0'
              textColor='#1a78c0'
            />
          </ButtonDownloadPWA>
          <ButtonDownloadPWAiOS>
            <DrawerButtonMenu
              icon={<InfoRounded />}
              text='¿Cómo instalar Tableros OSER?'
              iconColor='#1a78c0'
              textColor='#1a78c0'
            />
          </ButtonDownloadPWAiOS>
          <DrawerButtonMenu
            icon={<Verified />}
            text={`Version ${process.env.REACT_APP_MI_IOSPER_VERSION} ${
              process.env.REACT_APP_MI_IOSPER_VERSION_BETA_TEXT || ''
            }`}
            iconColor={colorVersion}
            textColor={colorVersion}
          />
        </List>
      </Box>
    </>
  );
};
